import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TableHead, LabelWrapper, TableColumn, TableColumnContent, TableContentDescription, TableContentValue } from './styles';
export var BracketsDesktop = function (_a) {
  var tableData = _a.tableData;
  return _jsxs(_Fragment, {
    children: [_jsx("thead", {
      children: _jsx("tr", {
        children: tableData.map(function (_a, i) {
          var description = _a.description;
          return _jsx(TableHead, {
            children: _jsx(LabelWrapper, {
              children: typeof description === 'string' ? _jsx(TableContentDescription, {
                children: description
              }) : description
            })
          }, i);
        })
      })
    }), _jsx("tbody", {
      children: _jsx("tr", {
        children: tableData.map(function (_a, i) {
          var value = _a.value;
          return _jsx(TableColumn, {
            children: _jsx(TableColumnContent, {
              children: typeof value === 'string' ? _jsx(TableContentValue, {
                children: value
              }) : value
            })
          }, i);
        })
      })
    })]
  });
};